var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spacer-block",class:{ selected: _vm.selected },style:({ height: (_vm.block.height || 16) + 'px' })},[(_vm.selected)?_c('span',{staticClass:"text-caption grey--text"},[_vm._v(" Abstand "+_vm._s(_vm.block.height || 16)+"px ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }